import { apiClient } from './client.js'

export const returnService = {
  createReturn: (data) => {
    return apiClient.post('/returns', data)
  },

  getOrderReturnableInfo: (orderId) => {
    return apiClient.get(`/orders/${orderId}/returns`)
  },

  getReturnDetail: (returnId) => {
    return apiClient.get(`/returns/${returnId}`)
  },

  listReturns: (params = {}) => {
    const query = new URLSearchParams()
    if (params.start_date) query.append('start_date', params.start_date)
    if (params.end_date) query.append('end_date', params.end_date)
    if (params.search) query.append('search', params.search)
    if (params.page) query.append('page', String(params.page))
    if (params.limit) query.append('limit', String(params.limit))
    return apiClient.get(`/returns${query.toString() ? `?${query.toString()}` : ''}`)
  },
}
